<template>
  <div>
    <div >
    <header>
      <modal v-if="showMaintain">
        <template #body>
          <div v-html="modalData.body"></div>
        </template>
        <template #header>
          <h3>{{ modalData.header }}</h3>
        </template>
        <template #button>
          <button @click="showMaintain = false" class="button-css">確定</button>
        </template>
      </modal>
      <div  :class='logoClass' v-if="(activeInfo.logoFlag === 'L' || activeInfo.logoFlag === 'A') && this.param.MGM ">
        <img  height="60px" :src='logoSrc'>
      </div>
      <div class="logo" v-if="!(activeInfo.logoFlag === 'A')">
        <img height="60px" :src='ctbcSrc'>
      </div>
      <div :class='logoClass' v-if="activeInfo.logoFlag === 'R' && this.param.MGM ">
        <img  height="60px" :src='logoSrc'>
      </div>
      <nav>
        <div class="link">
          <ul>
            <li v-for="(row,index) in menuList" :key="index" @click="click(row)">
              <a v-if="row.menuType === 'LINK'" target="_blank" :href="row.menuLink" style="cursor: pointer;">{{row.menuName}}</a>
              <a v-if="row.menuType === 'NOTICE'" style="cursor: pointer; ">{{row.menuName}}</a>
            </li>
          </ul>
          <modal v-if="showModal">
            <template #body>
              <div v-html="modalData.body"></div>
            </template>
            <template #header>
              <h3>{{ modalData.header }}</h3>
            </template>
            <template #button>
              <button @click="showModal = false" class="button-css">我瞭解了</button>
            </template>
          </modal>
        </div>
      </nav>
      <div class="s_menu">
          <a href="javascript:;" v-if="menuList.length > 0 && param.MGM">
              <img src="@/common/assets/ham.png" alt="下拉選單" title="下拉選單">
          </a>
      </div>
    </header>
    <router-view v-if="initFlag" v-slot="{ Component }">
      <transition :key="key">
        <component :is="Component" />
      </transition>
    </router-view>
    <loading loader="spinner"
        v-model:active= "isLoading"
        :is-full-page= "true">
    </loading>
    </div>
    <!-- <router-view/> -->
    <footer>
    <div class="block">
        <a class="footer_index" href="https://www.ctbcbank.com/twrbo/zh_tw/index/ctbc_aboutCTBC/ctbc_legal/ctbc_finances.html?targetTab=ctbc_finances_tab2" target="_blank"></a>
        <img src='@/common/assets/footer.png' alt="謹慎理財，信用至上。信用卡循環年利率=本行ARMs指數+加碼利率(5.97%~13.47%)，上限為15%，預借現金手續費為每筆預借金額x3.5%+150元，循環利率基準日為104年9月1日，其他費用請上官網查詢。" title="謹慎理財，信用至上。信用卡循環年利率=本行ARMs指數+加碼利率(5.97%~13.47%)，上限為15%，預借現金手續費為每筆預借金額x3.5%+150元，循環利率基準日為104年9月1日，其他費用請上官網查詢。">
    </div>
    </footer>
  </div>
</template>
<!-- <style src='./styles/css.css'></style> -->
<link rel="stylesheet" href="../css/font-awesome.min.css" />
<style src='@/common/styles/reset.css'></style>

<script>
import { commonMixin } from '@/common/mixins'
import modal from '../qrcodeMgm/components/embedded/modal'
import { mapState } from 'vuex'
import VueLoading from 'vue-loading-overlay'

export default {
  name: 'App',
  mixins: [commonMixin],
  components: {
    modal,
    loading: VueLoading
  },
  methods: {
    click (row) {
      if (row.menuType === 'NOTICE') {
        this.showModal = true
        this.modalData.body = row.noticeText
        this.modalData.header = row.menuName
      }
    },
    // YAP201901-340 [OB小版] 建立維護公告機制-F5 : 顯示停機公告
    clickShowMaintain () {
      this.post('showMaintain', {}, r => {
        if (r) {
          let c = r.split('|')
          this.modalData.header = c[0]
          this.modalData.body = c[1]
          this.showMaintain = true
        }
      }, () => {})
    },
    getActiveInfo () {
      // 取得 活動ID 所有資料
      let data = { MGM: this.param.MGM }
      this.post('getActiveInfo', data, r => {
        // 取得成功
        this.activeInfo = r
        if (this.activeInfo.logoFlag === 'A') {
          this.logoClass = 'logo'
        } else {
          this.logoClass = 'lg'
        }
        // 根據 activeId 取得 menuList
        this.getMenuList()
        document.title = r.activeTitle
        this.$store.commit('routeTransfer/update', { pageParams: this.param, activeInfo: r })
        this.$router.push({ name: 'qrcode' })
        this.initFlag = true
      }, () => {
        // console.log('getActiveInfo-2:' + JSON.stringify(e))
        // 錯誤導至 Error 頁
        this.goErrorPage('很抱歉，尚無法使用本服務，請稍後再試，謝謝!')
        this.initFlag = true
      })
    },
    getMenuList () {
      // 取得 menu 選單
      this.post('getObMenuInfo', { activeId: this.activeInfo.activeId }, r => {
        // 接收成功
        this.menuList = r
      })
    },
    waitUnattended () {
      let startTime = new Date().getTime()
      window.clearInterval(this.unattendedTimer)
      this.unattendedTimer = window.setInterval(() => {
        let now = new Date().getTime()
        if ((now - startTime) / 1000 > this.$network.timeout) {
          if (this.$route.path !== '/') {
            // 錯誤導至 Error 頁
            this.goErrorPage('很抱歉，操作閒置時間已逾時，謝謝!')
          }
          window.clearInterval(this.unattendedTimer)
        }
      }, 10 * 1000)
    }
  },
  created () {
    // 取得活動主檔資料
    this.param = {
      MGM: this.$utils.getUrlKey('MGM'),
      Pcode: this.$utils.getUrlKey('Pcode'),
      SPCCode: this.$utils.getUrlKey('SPCCode'),
      EmpCode: this.$utils.getUrlKey('EmpCode'),
      // 快打辦卡頁用
      CrdF: this.$utils.getUrlKey('CrdF'),
      CrdFace: this.$utils.getUrlKey('CrdFace'),
      CrdB: this.$utils.getUrlKey('CrdB'),
      CrdG: this.$utils.getUrlKey('CrdG'),
      Chnl: this.$utils.getUrlKey('Chnl'),
      Fa: this.$utils.getUrlKey('Fa')
    }
    // console.log('created:')
    this.getActiveInfo()
    // YAP201901-340 [OB小版] 建立維護公告機制-F5 : 顯示停機公告
    this.clickShowMaintain()
  },
  mounted () {
    // console.log('app.vue mounted')
    $()
    // axios 600 秒逾時
    this.$http.app(this)
    // 計時 Function
    this.waitUnattended()
    // 取得 logo 圖片
    this.ctbcSrc = this.$network.imgAddress + 'mgm/image/Logo.png'
    // 取得 網址列參數
    this.param = {
      MGM: this.$utils.getUrlKey('MGM'),
      Pcode: this.$utils.getUrlKey('Pcode'),
      SPCCode: this.$utils.getUrlKey('SPCCode'),
      EmpCode: this.$utils.getUrlKey('EmpCode'),
      // 快打辦卡頁用
      CrdF: this.$utils.getUrlKey('CrdF'),
      CrdFace: this.$utils.getUrlKey('CrdFace'),
      CrdB: this.$utils.getUrlKey('CrdB'),
      CrdG: this.$utils.getUrlKey('CrdG'),
      Chnl: this.$utils.getUrlKey('Chnl'),
      Fa: this.$utils.getUrlKey('Fa')
    }
    if (this.param.MGM === null) {
      this.$router.push({ name: 'error' })
    } else {
      // console.log('app.vue', JSON.stringify(this.param))
      // 取得 活動Logo圖片
      this.logoSrc = this.$network.imgAddress + 'mgm/image/' + this.param.MGM + '/Logo.png'
    }
  },
  data () {
    return {
      // YAP201901-340 [OB小版] 建立維護公告機制-F5 : 顯示停機公告
      showMaintain: false,
      // 連線計時
      initFlag: false,
      logoClass: null,
      unattendedTimer: 0,
      // 是否 popup 視窗
      showModal: false,
      // 網址參數
      param: null,
      // 清單
      menuList: [],
      modalData: {
        body: null,
        header: null
      },
      logoSrc: null,
      ctbcSrc: null,
      activeInfo: {
        // 活動Id
        activeId: null,
        // 活動代碼
        activeCode: null,
        // 活動名稱
        activeName: null,
        // 活動Title
        activeTitle: null,
        // LOGO 註記 N: 無, R: 右, L: 左
        logoFlag: null,
        // 活動文案
        activityCopy: null,
        // 注意事項文字
        noticeText: null,
        qrcodeNoticeText: null,
        // QRCode 文案
        qrcodeCopy: null,
        // 轉貼訊息
        repostMessage: null
      }
    }
  },
  computed: {
    ...mapState(['isLoading']),
    key () {
      // if (this.$utils.getUrlKey('MGM') && this.$route.name) {
      if (this.$utils.getUrlKey('MGM') && this.$route.name) {
        // location.reload()
      }
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  },
  watch: {
    $route (to) {
      if (to.name === 'qrcode' && to.query.MGM !== undefined) {
        if (this.param.MGM !== to.query.MGM ||
          this.param.Pcode !== to.query.Pcode ||
          this.param.EmpCode !== to.query.EmpCode ||
          this.param.SPCCode !== to.query.SPCCode) {
          location.reload()
        }
      }
    }
  }
}
</script>

<style lang="stylus">
#app
  font-family 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align center
  color #2c3e50

#nav
  padding 30px
  a
    font-weight bold
    color #2c3e50
    &.router-link-exact-active
      color #42b983
</style>
